function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import useHasPermission from '../../../helpers/hooks/useHasPermission';

// TODO :: make sure placeholder works, move to top and shrink on focus
var Input = function Input(_ref) {
  var _ref$id = _ref.id,
    pId = _ref$id === void 0 ? null : _ref$id,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? '' : _ref$value,
    _ref$placeholder = _ref.placeholder,
    placeholder = _ref$placeholder === void 0 ? null : _ref$placeholder,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'text' : _ref$type,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? null : _ref$onChange,
    _ref$onFocus = _ref.onFocus,
    onFocus = _ref$onFocus === void 0 ? null : _ref$onFocus,
    _ref$onBlur = _ref.onBlur,
    onBlur = _ref$onBlur === void 0 ? null : _ref$onBlur,
    _ref$titleCase = _ref.titleCase,
    titleCase = _ref$titleCase === void 0 ? false : _ref$titleCase,
    _ref$permission = _ref.permission,
    permission = _ref$permission === void 0 ? null : _ref$permission,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    _ref$fineprint = _ref.fineprint,
    fineprint = _ref$fineprint === void 0 ? null : _ref$fineprint,
    _ref$button = _ref.button,
    button = _ref$button === void 0 ? null : _ref$button;
  var _useState = useState(pId || uuid()),
    _useState2 = _slicedToArray(_useState, 1),
    id = _useState2[0];
  var hasPermission = useHasPermission(permission);
  var toTitleCase = function toTitleCase(str) {
    var lowers = ['a', 'an', 'and', 'as', 'at', 'but', 'by', 'for', 'for', 'from', 'in', 'into', 'is', 'near', 'nor', 'of', 'on', 'onto', 'or', 'the', 'to', 'with'];
    var uppers = ['U.S.', 'USA'];
    return str.split(' ').map(function (x, i) {
      if (i === 0) return x.charAt(0).toUpperCase() + x.substr(1).toLowerCase();else if (lowers.includes(x.toLowerCase())) return x.toLowerCase();else if (uppers.includes(x.toUpperCase())) return x.toUpperCase();else return x.charAt(0).toUpperCase() + x.substr(1).toLowerCase();
    }).join(' ');
  };
  var handleOnChange = function handleOnChange(e) {
    // if (value.length > 0) {
    // }

    if (titleCase) e.target.value = toTitleCase(e.target.value);
    if (onChange) onChange(e);
  };
  var handleOnFocus = function handleOnFocus(e) {
    if (onFocus) onFocus(e);
    if (label) $("#".concat(id, "-label")).addClass('input-text__label--focus');
  };
  var handleOnBlur = function handleOnBlur(e) {
    // if (value.length === 0) {
    // }

    if (onBlur) onBlur(e);
    if (value.length === 0 && label) $("#".concat(id, "-label")).removeClass('input-text__label--focus');
  };
  useEffect(function () {
    if (label) if ($("#".concat(id, "-input")).val().length > 0) handleOnFocus();
  }, [value]);
  var inputStyle = {};
  if (label) {
    inputStyle.paddingTop = 11;
    inputStyle.paddingLeft = 17.5;
    inputStyle.height = 42;
  }
  if (label) style.height = 42;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "input-text ".concat(className),
    style: style
  }, label && /*#__PURE__*/React.createElement("div", {
    id: "".concat(id, "-label"),
    className: "input-text__label"
  }, label), /*#__PURE__*/React.createElement("input", {
    id: "".concat(id, "-input"),
    type: type,
    value: value,
    disabled: disabled || !hasPermission,
    onChange: handleOnChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    placeholder: placeholder,
    style: inputStyle
  }), fineprint && /*#__PURE__*/React.createElement("div", {
    className: "input-text__fineprint"
  }, fineprint), button && /*#__PURE__*/React.createElement("div", {
    className: "input-text__button",
    onClick: function onClick() {
      if (button.onClick) button.onClick();
    }
  }, button.label || 'Click me'));
};
export default Input;

/*

			{placeholder && <label htmlFor={`${id}-input`}>{placeholder}</label>}


*/